export function getdata() {
	var obj = {
		mboptions: [{
				label: "标准模板",
				value: "0"
			},
			{
				label: "自定义模板",
				value: "1",
			}
		],
		headData: [{
				title: "业务科目代码",
				prop: "yewkmCode",
				width: "200px",
				issort: true,
			},
			{
				title: "业务科目名称",
				prop: "yewkmName",
				width: "200px",
				issort: true,
			},
			{
				title: "申报税种",
				prop: "declareType",
				width: "200px",
				issort: true,
				custom: true
			},
			{
				title: "报表名称",
				prop: "reportName",
				width: "200px",
				issort: true,
			},
			{
				title: "是否启用",
				prop: "enableFlag",
				width: "200px",
				issort: true,
				custom: true
			},
			{
				title: "映射方式",
				prop: "sourceFlag",
				width: "200px",
				issort: true,
				custom: true
			},
			{
				title: "对应公司科目代码",
				prop: "subjectCodes",
				width: "200px",
				issort: true,
			},
			{
				title: "对应公司科目名称",
				prop: "companySubjectName",
				width: "200px",
				issort: true,
			},
			{
				title: "说明",
				prop: "notes",
				width: "200px",
				issort: true,
			},
			{
				title: "操作",
				prop: "cz",
				custom: true,
				fixed: 'right'
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
